import { render } from "./SuperFundsNewModalPopup.vue?vue&type=template&id=317f51b1&scoped=true"
import script from "./SuperFundsNewModalPopup.vue?vue&type=script&lang=js"
export * from "./SuperFundsNewModalPopup.vue?vue&type=script&lang=js"

import "./SuperFundsNewModalPopup.vue?vue&type=style&index=0&id=317f51b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317f51b1"]])

export default __exports__